<template>
    <div id="single-post-header">
        <div class="single-post" v-if="post.id">
            <div class="post-title-area col-12 pl-0">
                <a class="post-cat" :href="post.keywords_search_url" v-if="post.first_keyword">{{ post.first_keyword }}</a>
                <h2 class="post-title">
                    {{ post.title }}
                </h2>
                <div class="post-meta">
								<span class="post-author">
									<a :href="post.list_url">{{ post.menu_name }}</a>
								</span>
                    <span class="post-date"><i class="fa fa-clock-o"></i> {{ post.creation_date | formatShortDate }}</span>
                </div>
            </div><!-- Post title end -->
        </div>
        <h5 class="text-dark" v-else>A cikk jelenleg nem elérhető.</h5>
    </div>
</template>

<script>
    export default {
        name: 'SinglePostHeader',
        props: ['data'],
        data() {
            return {
                post: this.data ? this.data : {},
            }
        },
        watch: {
            data: function (newVal) {
                this.post = newVal;
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    #single-post-header {
        .post-title {
            font-size: 30px;
            line-height: 40px;
            padding: 15px 0 8px 0;
            margin: 0;
        }

        .post-meta {
            padding-bottom: 15px;

            span {
                font-size: 12px;
                color: #a3a3a3;
                margin-right: 8px;
                padding-right: 10px;
                border-right: 1px solid #dedede;
                line-height: 12px;
                display: inline-block;

                i {
                    margin-right: 5px;
                }
            }

            .post-author {
                a {
                    color: #1c1c1c;
                    font-weight: 700;
                }
            }

            .post-date {
                border-right: 0;
            }

            .post-edit {
                i, a, span {
                    color: $red;
                }

                a:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>